const twareasData = []
const countryData = [
  { ID: 1, Name: '中國(大陸)' },
  { ID: 2, Name: '中國(香港)' },
  { ID: 3, Name: '中國(澳門)' },
  { ID: 4, Name: '中國(台灣)' },
  { ID: 5, Name: '其他國家及地區' },
]
const provinceData = [
  { Country: 1, ID: 1, Name: '北京' },
  { Country: 1, ID: 2, Name: '吉林省' },
  { Country: 1, ID: 3, Name: '黑龍江省' },
  { Country: 1, ID: 4, Name: '上海' },
  { Country: 1, ID: 5, Name: '江蘇省' },
  { Country: 1, ID: 6, Name: '浙江省' },
  { Country: 1, ID: 7, Name: '安徽省' },
  { Country: 1, ID: 8, Name: '福建省' },
  { Country: 1, ID: 9, Name: '江西省' },
  { Country: 1, ID: 10, Name: '山東省' },
  { Country: 1, ID: 11, Name: '河南省' },
  { Country: 1, ID: 12, Name: '湖北省' },
  { Country: 1, ID: 13, Name: '湖南省' },
  { Country: 1, ID: 14, Name: '廣東省' },
  { Country: 1, ID: 15, Name: '廣西壯族自治區' },
  { Country: 1, ID: 16, Name: '海南省' },
  { Country: 1, ID: 17, Name: '重慶' },
  { Country: 1, ID: 18, Name: '四川省' },
  { Country: 1, ID: 19, Name: '貴州省' },
  { Country: 1, ID: 20, Name: '雲南省' },
  { Country: 1, ID: 21, Name: '西藏自治區' },
  { Country: 1, ID: 22, Name: '陝西省' },
  { Country: 1, ID: 23, Name: '甘肅省' },
  { Country: 1, ID: 24, Name: '青海省' },
  { Country: 1, ID: 25, Name: '寧夏回族自治區' },
  { Country: 1, ID: 26, Name: '新疆維吾爾自治區' },
  { Country: 4, ID: 27, Name: '台灣省' },
  { Country: 2, ID: 28, Name: '香港特別行政區' },
  { Country: 3, ID: 29, Name: '澳門特別行政區' },
  { Country: 5, ID: 30, Name: '海外' },
  { Country: 1, ID: 31, Name: '天津' },
  { Country: 1, ID: 32, Name: '遼寧省' },
  { Country: 1, ID: 33, Name: '內蒙古自治區' },
  { Country: 1, ID: 34, Name: '山西省' },
  { Country: 1, ID: 35, Name: '河北省' },
  { Country: 2, ID: 36, Name: '其他' },
]
const cityData = [
  { Province: 1, ID: 1, Name: '北京市' },
  { Province: 2, ID: 2, Name: '長春市' },
  { Province: 2, ID: 3, Name: '吉林市' },
  { Province: 2, ID: 4, Name: '四平市' },
  { Province: 2, ID: 5, Name: '遼源市' },
  { Province: 2, ID: 6, Name: '通化市' },
  { Province: 2, ID: 7, Name: '白山市' },
  { Province: 2, ID: 8, Name: '松原市' },
  { Province: 2, ID: 9, Name: '白城市' },
  { Province: 2, ID: 10, Name: '延邊朝鮮族自治州' },
  { Province: 3, ID: 11, Name: '哈爾濱市' },
  { Province: 3, ID: 12, Name: '齊齊哈爾市' },
  { Province: 3, ID: 13, Name: '雞西市' },
  { Province: 3, ID: 14, Name: '鶴崗市' },
  { Province: 3, ID: 15, Name: '雙鴨山市' },
  { Province: 3, ID: 16, Name: '大慶市' },
  { Province: 3, ID: 17, Name: '伊春市' },
  { Province: 3, ID: 18, Name: '佳木斯市' },
  { Province: 3, ID: 19, Name: '七台河市' },
  { Province: 3, ID: 20, Name: '牡丹江市' },
  { Province: 3, ID: 21, Name: '黑河市' },
  { Province: 3, ID: 22, Name: '綏化市' },
  { Province: 3, ID: 23, Name: '大興安嶺地區' },
  { Province: 4, ID: 24, Name: '上海市' },
  { Province: 5, ID: 25, Name: '南京市' },
  { Province: 5, ID: 26, Name: '無錫市' },
  { Province: 5, ID: 27, Name: '徐州市' },
  { Province: 5, ID: 28, Name: '常州市' },
  { Province: 5, ID: 29, Name: '蘇州市' },
  { Province: 5, ID: 30, Name: '南通市' },
  { Province: 5, ID: 31, Name: '連雲港市' },
  { Province: 5, ID: 32, Name: '淮安市' },
  { Province: 5, ID: 33, Name: '鹽城市' },
  { Province: 5, ID: 34, Name: '揚州市' },
  { Province: 5, ID: 35, Name: '鎮江市' },
  { Province: 5, ID: 36, Name: '泰州市' },
  { Province: 5, ID: 37, Name: '宿遷市' },
  { Province: 6, ID: 38, Name: '杭州市' },
  { Province: 6, ID: 39, Name: '寧波市' },
  { Province: 6, ID: 40, Name: '溫州市' },
  { Province: 6, ID: 41, Name: '嘉興市' },
  { Province: 6, ID: 42, Name: '湖州市' },
  { Province: 6, ID: 43, Name: '紹興市' },
  { Province: 6, ID: 44, Name: '金華市' },
  { Province: 6, ID: 45, Name: '衢州市' },
  { Province: 6, ID: 46, Name: '舟山市' },
  { Province: 6, ID: 47, Name: '台州市' },
  { Province: 6, ID: 48, Name: '麗水市' },
  { Province: 7, ID: 49, Name: '合肥市' },
  { Province: 7, ID: 50, Name: '蕪湖市' },
  { Province: 7, ID: 51, Name: '蚌埠市' },
  { Province: 7, ID: 52, Name: '淮南市' },
  { Province: 7, ID: 53, Name: '馬鞍山市' },
  { Province: 7, ID: 54, Name: '淮北市' },
  { Province: 7, ID: 55, Name: '銅陵市' },
  { Province: 7, ID: 56, Name: '安慶市' },
  { Province: 7, ID: 57, Name: '黃山市' },
  { Province: 7, ID: 58, Name: '滁州市' },
  { Province: 7, ID: 59, Name: '阜陽市' },
  { Province: 7, ID: 60, Name: '宿州市' },
  { Province: 7, ID: 61, Name: '六安市' },
  { Province: 7, ID: 62, Name: '亳州市' },
  { Province: 7, ID: 63, Name: '池州市' },
  { Province: 7, ID: 64, Name: '宣城市' },
  { Province: 8, ID: 65, Name: '福州市' },
  { Province: 8, ID: 66, Name: '廈門市' },
  { Province: 8, ID: 67, Name: '莆田市' },
  { Province: 8, ID: 68, Name: '三明市' },
  { Province: 8, ID: 69, Name: '泉州市' },
  { Province: 8, ID: 70, Name: '漳州市' },
  { Province: 8, ID: 71, Name: '南平市' },
  { Province: 8, ID: 72, Name: '龍巖市' },
  { Province: 8, ID: 73, Name: '寧德市' },
  { Province: 9, ID: 74, Name: '南昌市' },
  { Province: 9, ID: 75, Name: '景德鎮市' },
  { Province: 9, ID: 76, Name: '萍鄉市' },
  { Province: 9, ID: 77, Name: '九江市' },
  { Province: 9, ID: 78, Name: '新余市' },
  { Province: 9, ID: 79, Name: '鷹潭市' },
  { Province: 9, ID: 80, Name: '贛州市' },
  { Province: 9, ID: 81, Name: '吉安市' },
  { Province: 9, ID: 82, Name: '宜春市' },
  { Province: 9, ID: 83, Name: '撫州市' },
  { Province: 9, ID: 84, Name: '上饒市' },
  { Province: 10, ID: 85, Name: '濟南市' },
  { Province: 10, ID: 86, Name: '青島市' },
  { Province: 10, ID: 87, Name: '淄博市' },
  { Province: 10, ID: 88, Name: '棗莊市' },
  { Province: 10, ID: 89, Name: '東營市' },
  { Province: 10, ID: 90, Name: '煙台市' },
  { Province: 10, ID: 91, Name: '濰坊市' },
  { Province: 10, ID: 92, Name: '濟寧市' },
  { Province: 10, ID: 93, Name: '泰安市' },
  { Province: 10, ID: 94, Name: '威海市' },
  { Province: 10, ID: 95, Name: '日照市' },
  { Province: 10, ID: 96, Name: '萊蕪市' },
  { Province: 10, ID: 97, Name: '臨沂市' },
  { Province: 10, ID: 98, Name: '德州市' },
  { Province: 10, ID: 99, Name: '聊城市' },
  { Province: 10, ID: 100, Name: '濱州市' },
  { Province: 10, ID: 101, Name: '菏澤市' },
  { Province: 11, ID: 102, Name: '鄭州市' },
  { Province: 11, ID: 103, Name: '開封市' },
  { Province: 11, ID: 104, Name: '洛陽市' },
  { Province: 11, ID: 105, Name: '平頂山市' },
  { Province: 11, ID: 106, Name: '安陽市' },
  { Province: 11, ID: 107, Name: '鶴壁市' },
  { Province: 11, ID: 108, Name: '新鄉市' },
  { Province: 11, ID: 109, Name: '焦作市' },
  { Province: 11, ID: 110, Name: '濟源市' },
  { Province: 11, ID: 111, Name: '濮陽市' },
  { Province: 11, ID: 112, Name: '許昌市' },
  { Province: 11, ID: 113, Name: '漯河市' },
  { Province: 11, ID: 114, Name: '三門峽市' },
  { Province: 11, ID: 115, Name: '南陽市' },
  { Province: 11, ID: 116, Name: '商丘市' },
  { Province: 11, ID: 117, Name: '信陽市' },
  { Province: 11, ID: 118, Name: '周口市' },
  { Province: 11, ID: 119, Name: '駐馬店市' },
  { Province: 12, ID: 120, Name: '武漢市' },
  { Province: 12, ID: 121, Name: '黃石市' },
  { Province: 12, ID: 122, Name: '十堰市' },
  { Province: 12, ID: 123, Name: '宜昌市' },
  { Province: 12, ID: 124, Name: '襄陽市' },
  { Province: 12, ID: 125, Name: '鄂州市' },
  { Province: 12, ID: 126, Name: '荊門市' },
  { Province: 12, ID: 127, Name: '孝感市' },
  { Province: 12, ID: 128, Name: '荊州市' },
  { Province: 12, ID: 129, Name: '黃岡市' },
  { Province: 12, ID: 130, Name: '咸寧市' },
  { Province: 12, ID: 131, Name: '隨州市' },
  { Province: 12, ID: 132, Name: '恩施土家族苗族自治州' },
  { Province: 12, ID: 133, Name: '仙桃市' },
  { Province: 12, ID: 134, Name: '潛江市' },
  { Province: 12, ID: 135, Name: '天門市' },
  { Province: 12, ID: 136, Name: '神農架林區' },
  { Province: 13, ID: 137, Name: '長沙市' },
  { Province: 13, ID: 138, Name: '株洲市' },
  { Province: 13, ID: 139, Name: '湘潭市' },
  { Province: 13, ID: 140, Name: '衡陽市' },
  { Province: 13, ID: 141, Name: '邵陽市' },
  { Province: 13, ID: 142, Name: '岳陽市' },
  { Province: 13, ID: 143, Name: '常德市' },
  { Province: 13, ID: 144, Name: '張家界市' },
  { Province: 13, ID: 145, Name: '益陽市' },
  { Province: 13, ID: 146, Name: '郴州市' },
  { Province: 13, ID: 147, Name: '永州市' },
  { Province: 13, ID: 148, Name: '懷化市' },
  { Province: 13, ID: 149, Name: '婁底市' },
  { Province: 13, ID: 150, Name: '湘西土家族苗族自治州' },
  { Province: 14, ID: 151, Name: '廣州市' },
  { Province: 14, ID: 152, Name: '韶關市' },
  { Province: 14, ID: 153, Name: '深圳市' },
  { Province: 14, ID: 154, Name: '珠海市' },
  { Province: 14, ID: 155, Name: '汕頭市' },
  { Province: 14, ID: 156, Name: '佛山市' },
  { Province: 14, ID: 157, Name: '江門市' },
  { Province: 14, ID: 158, Name: '湛江市' },
  { Province: 14, ID: 159, Name: '茂名市' },
  { Province: 14, ID: 160, Name: '肇慶市' },
  { Province: 14, ID: 161, Name: '惠州市' },
  { Province: 14, ID: 162, Name: '梅州市' },
  { Province: 14, ID: 163, Name: '汕尾市' },
  { Province: 14, ID: 164, Name: '河源市' },
  { Province: 14, ID: 165, Name: '陽江市' },
  { Province: 14, ID: 166, Name: '清遠市' },
  { Province: 14, ID: 167, Name: '東莞市' },
  { Province: 14, ID: 168, Name: '中山市' },
  { Province: 14, ID: 169, Name: '潮州市' },
  { Province: 14, ID: 170, Name: '揭陽市' },
  { Province: 14, ID: 171, Name: '雲浮市' },
  { Province: 15, ID: 172, Name: '南寧市' },
  { Province: 15, ID: 173, Name: '柳州市' },
  { Province: 15, ID: 174, Name: '桂林市' },
  { Province: 15, ID: 175, Name: '梧州市' },
  { Province: 15, ID: 176, Name: '北海市' },
  { Province: 15, ID: 177, Name: '防城港市' },
  { Province: 15, ID: 178, Name: '欽州市' },
  { Province: 15, ID: 179, Name: '貴港市' },
  { Province: 15, ID: 180, Name: '玉林市' },
  { Province: 15, ID: 181, Name: '百色市' },
  { Province: 15, ID: 182, Name: '賀州市' },
  { Province: 15, ID: 183, Name: '河池市' },
  { Province: 15, ID: 184, Name: '來賓市' },
  { Province: 15, ID: 185, Name: '崇左市' },
  { Province: 16, ID: 186, Name: '海口市' },
  { Province: 16, ID: 187, Name: '三亞市' },
  { Province: 16, ID: 188, Name: '五指山市' },
  { Province: 16, ID: 189, Name: '瓊海市' },
  { Province: 16, ID: 190, Name: '儋州市' },
  { Province: 16, ID: 191, Name: '文昌市' },
  { Province: 16, ID: 192, Name: '萬寧市' },
  { Province: 16, ID: 193, Name: '東方市' },
  { Province: 16, ID: 194, Name: '定安縣' },
  { Province: 16, ID: 195, Name: '屯昌縣' },
  { Province: 16, ID: 196, Name: '澄邁縣' },
  { Province: 16, ID: 197, Name: '臨高縣' },
  { Province: 16, ID: 198, Name: '白沙黎族自治縣' },
  { Province: 16, ID: 199, Name: '昌江黎族自治縣' },
  { Province: 16, ID: 200, Name: '樂東黎族自治縣' },
  { Province: 16, ID: 201, Name: '陵水黎族自治縣' },
  { Province: 16, ID: 202, Name: '保亭黎族苗族自治縣' },
  { Province: 16, ID: 203, Name: '瓊中黎族苗族自治縣' },
  { Province: 16, ID: 204, Name: '西沙群島' },
  { Province: 16, ID: 205, Name: '南沙群島' },
  { Province: 16, ID: 206, Name: '中沙群島的島礁及其海域' },
  { Province: 17, ID: 207, Name: '重慶市' },
  { Province: 18, ID: 208, Name: '成都市' },
  { Province: 18, ID: 209, Name: '自貢市' },
  { Province: 18, ID: 210, Name: '攀枝花市' },
  { Province: 18, ID: 211, Name: '瀘州市' },
  { Province: 18, ID: 212, Name: '德陽市' },
  { Province: 18, ID: 213, Name: '綿陽市' },
  { Province: 18, ID: 214, Name: '廣元市' },
  { Province: 18, ID: 215, Name: '遂寧市' },
  { Province: 18, ID: 216, Name: '內江市' },
  { Province: 18, ID: 217, Name: '樂山市' },
  { Province: 18, ID: 218, Name: '南充市' },
  { Province: 18, ID: 219, Name: '眉山市' },
  { Province: 18, ID: 220, Name: '宜賓市' },
  { Province: 18, ID: 221, Name: '廣安市' },
  { Province: 18, ID: 222, Name: '達州市' },
  { Province: 18, ID: 223, Name: '雅安市' },
  { Province: 18, ID: 224, Name: '巴中市' },
  { Province: 18, ID: 225, Name: '資陽市' },
  { Province: 18, ID: 226, Name: '阿壩藏族羌族自治州' },
  { Province: 18, ID: 227, Name: '甘孜藏族自治州' },
  { Province: 18, ID: 228, Name: '涼山彝族自治州' },
  { Province: 19, ID: 229, Name: '貴陽市' },
  { Province: 19, ID: 230, Name: '六盤水市' },
  { Province: 19, ID: 231, Name: '遵義市' },
  { Province: 19, ID: 232, Name: '安順市' },
  { Province: 19, ID: 233, Name: '銅仁地區' },
  { Province: 19, ID: 234, Name: '黔西南布依族苗族自治州' },
  { Province: 19, ID: 235, Name: '畢節地區' },
  { Province: 19, ID: 236, Name: '黔東南苗族侗族自治州' },
  { Province: 19, ID: 237, Name: '黔南布依族苗族自治州' },
  { Province: 20, ID: 238, Name: '昆明市' },
  { Province: 20, ID: 239, Name: '曲靖市' },
  { Province: 20, ID: 240, Name: '玉溪市' },
  { Province: 20, ID: 241, Name: '保山市' },
  { Province: 20, ID: 242, Name: '昭通市' },
  { Province: 20, ID: 243, Name: '麗江市' },
  { Province: 20, ID: 244, Name: '普洱市' },
  { Province: 20, ID: 245, Name: '臨滄市' },
  { Province: 20, ID: 246, Name: '楚雄彝族自治州' },
  { Province: 20, ID: 247, Name: '紅河哈尼族彝族自治州' },
  { Province: 20, ID: 248, Name: '文山壯族苗族自治州' },
  { Province: 20, ID: 249, Name: '西雙版納傣族自治州' },
  { Province: 20, ID: 250, Name: '大理白族自治州' },
  { Province: 20, ID: 251, Name: '德宏傣族景頗族自治州' },
  { Province: 20, ID: 252, Name: '怒江傈僳族自治州' },
  { Province: 20, ID: 253, Name: '迪慶藏族自治州' },
  { Province: 21, ID: 254, Name: '拉薩市' },
  { Province: 21, ID: 255, Name: '昌都地區' },
  { Province: 21, ID: 256, Name: '山南地區' },
  { Province: 21, ID: 257, Name: '日喀則地區' },
  { Province: 21, ID: 258, Name: '那曲地區' },
  { Province: 21, ID: 259, Name: '阿里地區' },
  { Province: 21, ID: 260, Name: '林芝地區' },
  { Province: 22, ID: 261, Name: '西安市' },
  { Province: 22, ID: 262, Name: '銅川市' },
  { Province: 22, ID: 263, Name: '寶雞市' },
  { Province: 22, ID: 264, Name: '咸陽市' },
  { Province: 22, ID: 265, Name: '渭南市' },
  { Province: 22, ID: 266, Name: '延安市' },
  { Province: 22, ID: 267, Name: '漢中市' },
  { Province: 22, ID: 268, Name: '榆林市' },
  { Province: 22, ID: 269, Name: '安康市' },
  { Province: 22, ID: 270, Name: '商洛市' },
  { Province: 23, ID: 271, Name: '蘭州市' },
  { Province: 23, ID: 272, Name: '嘉峪關市' },
  { Province: 23, ID: 273, Name: '金昌市' },
  { Province: 23, ID: 274, Name: '白銀市' },
  { Province: 23, ID: 275, Name: '天水市' },
  { Province: 23, ID: 276, Name: '武威市' },
  { Province: 23, ID: 277, Name: '張掖市' },
  { Province: 23, ID: 278, Name: '平涼市' },
  { Province: 23, ID: 279, Name: '酒泉市' },
  { Province: 23, ID: 280, Name: '慶陽市' },
  { Province: 23, ID: 281, Name: '定西市' },
  { Province: 23, ID: 282, Name: '隴南市' },
  { Province: 23, ID: 283, Name: '臨夏回族自治州' },
  { Province: 23, ID: 284, Name: '甘南藏族自治州' },
  { Province: 24, ID: 285, Name: '西寧市' },
  { Province: 24, ID: 286, Name: '海東地區' },
  { Province: 24, ID: 287, Name: '海北藏族自治州' },
  { Province: 24, ID: 288, Name: '黃南藏族自治州' },
  { Province: 24, ID: 289, Name: '海南藏族自治州' },
  { Province: 24, ID: 290, Name: '果洛藏族自治州' },
  { Province: 24, ID: 291, Name: '玉樹藏族自治州' },
  { Province: 24, ID: 292, Name: '海西蒙古族藏族自治州' },
  { Province: 25, ID: 293, Name: '銀川市' },
  { Province: 25, ID: 294, Name: '石嘴山市' },
  { Province: 25, ID: 295, Name: '吳忠市' },
  { Province: 25, ID: 296, Name: '固原市' },
  { Province: 25, ID: 297, Name: '中衛市' },
  { Province: 26, ID: 298, Name: '烏魯木齊市' },
  { Province: 26, ID: 299, Name: '克拉瑪依市' },
  { Province: 26, ID: 300, Name: '吐魯番地區' },
  { Province: 26, ID: 301, Name: '哈密地區' },
  { Province: 26, ID: 302, Name: '昌吉回族自治州' },
  { Province: 26, ID: 303, Name: '博爾塔拉蒙古自治州' },
  { Province: 26, ID: 304, Name: '巴音郭楞蒙古自治州' },
  { Province: 26, ID: 305, Name: '阿克蘇地區' },
  { Province: 26, ID: 306, Name: '克孜勒蘇柯爾克孜自治州' },
  { Province: 26, ID: 307, Name: '喀什地區' },
  { Province: 26, ID: 308, Name: '和田地區' },
  { Province: 26, ID: 309, Name: '伊犁哈薩克自治州' },
  { Province: 26, ID: 310, Name: '塔城地區' },
  { Province: 26, ID: 311, Name: '阿勒泰地區' },
  { Province: 26, ID: 312, Name: '石河子市' },
  { Province: 26, ID: 313, Name: '阿拉爾市' },
  { Province: 26, ID: 314, Name: '圖木舒克市' },
  { Province: 26, ID: 315, Name: '五家渠市' },
  { Province: 27, ID: 316, Name: '台北市' },
  { Province: 27, ID: 317, Name: '高雄市' },
  { Province: 27, ID: 318, Name: '台南市' },
  { Province: 27, ID: 319, Name: '台中市' },
  { Province: 27, ID: 320, Name: '金門縣' },
  { Province: 27, ID: 321, Name: '南投縣' },
  { Province: 27, ID: 322, Name: '基隆市' },
  { Province: 27, ID: 323, Name: '新竹市' },
  { Province: 27, ID: 324, Name: '嘉義市' },
  { Province: 27, ID: 325, Name: '新北市' },
  { Province: 27, ID: 326, Name: '宜蘭縣' },
  { Province: 27, ID: 327, Name: '新竹縣' },
  { Province: 27, ID: 328, Name: '桃園縣' },
  { Province: 27, ID: 329, Name: '苗栗縣' },
  { Province: 27, ID: 330, Name: '彰化縣' },
  { Province: 27, ID: 331, Name: '嘉義縣' },
  { Province: 27, ID: 332, Name: '雲林縣' },
  { Province: 27, ID: 333, Name: '屏東縣' },
  { Province: 27, ID: 334, Name: '台東縣' },
  { Province: 27, ID: 335, Name: '花蓮縣' },
  { Province: 27, ID: 336, Name: '澎湖縣' },
  { Province: 28, ID: 337, Name: '香港島' },
  { Province: 28, ID: 338, Name: '九龍' },
  { Province: 28, ID: 339, Name: '新界' },
  { Province: 29, ID: 340, Name: '澳門半島' },
  { Province: 29, ID: 341, Name: '離島' },
  { Province: 30, ID: 342, Name: '海外' },
  { Province: 31, ID: 343, Name: '天津市' },
  { Province: 32, ID: 344, Name: '瀋陽市' },
  { Province: 32, ID: 345, Name: '大連市' },
  { Province: 32, ID: 346, Name: '鞍山市' },
  { Province: 32, ID: 347, Name: '撫順市' },
  { Province: 32, ID: 348, Name: '本溪市' },
  { Province: 32, ID: 349, Name: '丹東市' },
  { Province: 32, ID: 350, Name: '錦州市' },
  { Province: 32, ID: 351, Name: '營口市' },
  { Province: 32, ID: 352, Name: '阜新市' },
  { Province: 32, ID: 353, Name: '遼陽市' },
  { Province: 32, ID: 354, Name: '盤錦市' },
  { Province: 32, ID: 355, Name: '鐵嶺市' },
  { Province: 32, ID: 356, Name: '朝陽市' },
  { Province: 32, ID: 357, Name: '葫蘆島市' },
  { Province: 33, ID: 358, Name: '呼和浩特市' },
  { Province: 33, ID: 359, Name: '包頭市' },
  { Province: 33, ID: 360, Name: '烏海市' },
  { Province: 33, ID: 361, Name: '赤峰市' },
  { Province: 33, ID: 362, Name: '通遼市' },
  { Province: 33, ID: 363, Name: '鄂爾多斯市' },
  { Province: 33, ID: 364, Name: '呼倫貝爾市' },
  { Province: 33, ID: 365, Name: '巴彥淖爾市' },
  { Province: 33, ID: 366, Name: '烏蘭察布市' },
  { Province: 33, ID: 367, Name: '興安盟' },
  { Province: 33, ID: 368, Name: '錫林郭勒盟' },
  { Province: 33, ID: 369, Name: '阿拉善盟' },
  { Province: 34, ID: 370, Name: '太原市' },
  { Province: 34, ID: 371, Name: '大同市' },
  { Province: 34, ID: 372, Name: '陽泉市' },
  { Province: 34, ID: 373, Name: '長治市' },
  { Province: 34, ID: 374, Name: '晉城市' },
  { Province: 34, ID: 375, Name: '朔州市' },
  { Province: 34, ID: 376, Name: '晉中市' },
  { Province: 34, ID: 377, Name: '運城市' },
  { Province: 34, ID: 378, Name: '忻州市' },
  { Province: 34, ID: 379, Name: '臨汾市' },
  { Province: 34, ID: 380, Name: '呂梁市' },
  { Province: 35, ID: 381, Name: '石家莊市' },
  { Province: 35, ID: 382, Name: '唐山市' },
  { Province: 35, ID: 383, Name: '秦皇島市' },
  { Province: 35, ID: 384, Name: '邯鄲市' },
  { Province: 35, ID: 385, Name: '邢台市' },
  { Province: 35, ID: 386, Name: '保定市' },
  { Province: 35, ID: 387, Name: '張家口市' },
  { Province: 35, ID: 388, Name: '承德市' },
  { Province: 35, ID: 389, Name: '滄州市' },
  { Province: 35, ID: 390, Name: '廊坊市' },
  { Province: 35, ID: 391, Name: '衡水市' },
  { Province: 36, ID: 392, Name: '其他' },
  { Province: 26, ID: 393, Name: '昌吉州呼圖壁縣' },
  { Province: 11, ID: 394, Name: '長葛市' },
  { Province: 8, ID: 395, Name: '晉江市' },
]
//仅省市选择
for (const provinceItem of provinceData) {
  twareasData.push({
    value: provinceItem.ID, // 省份code值
    label: provinceItem.Name, // 省份汉字
    children: [],
  })
}

for (const provinceItem of twareasData) {
  for (const cityItem of cityData) {
    if (cityItem.Province === provinceItem.value) {
      provinceItem.children.push({
        value: cityItem.ID,
        label: cityItem.Name,
      })
    }
  }
}
export default twareasData



// WEBPACK FOOTER //
// ./src/utils/twarea.js